/** Checkout invalidates this key once a payment settles. */
export const patientDiscountsQueryKey = (patientId: string) =>
  ["patient", patientId, "discounts"] as const;
